exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.logo__wrapper[data-v-0a3eea97] {\n  display: block;\n}\n.st0[data-v-0a3eea97] {\n  fill: #ffffff;\n}\n.st1[data-v-0a3eea97] {\n  fill: #ba2d21;\n}\n", "", {"version":3,"sources":["/docker/tv-app/frontend/src/assets/logos/src/assets/logos/LogoDigmedia.vue"],"names":[],"mappings":";AAoBA;EACA,eAAA;CACA;AAEA;EACA,cAAA;CACA;AACA;EACA,cAAA;CACA","file":"LogoDigmedia.vue","sourcesContent":["<template>\n  <div class=\"logo__wrapper\">\n\n  </div>\n</template>\n\n<script>\nexport default {\n  components: {},\n  props: {\n    width: {\n      type: Number,\n      default: 100,\n    },\n  },\n  emits: {},\n};\n</script>\n\n<style scoped>\n.logo__wrapper {\n  display: block;\n}\n\n.st0 {\n  fill: #ffffff;\n}\n.st1 {\n  fill: #ba2d21;\n}\n</style>\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a3eea97","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/assets/logos/LogoDigmedia.vue
// module id = okfp
// module chunks = 1